var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateAsapHeader } from '@atlassiansox/asc-asap';
import { mapResponseToJson } from '@atlassiansox/asc-core';
import { fetch, Headers } from 'cross-fetch';
export const STAGING_BASE_URL = 'https://wac.stg.internal.atlassian.com/apis/stg/cnas';
export const PRODUCTION_BASE_URL = 'https://www.atlassian.com/apis/prod/cnas';
export const ASAP_AUDIENCE = 'cloud-name-availability';
export class CnasClient {
    constructor({ baseUrl = STAGING_BASE_URL } = {}) {
        this.baseUrl = baseUrl;
    }
    getNameAvailability({ cloudName }) {
        return __awaiter(this, void 0, void 0, function* () {
            return mapResponseToJson(yield fetch(`${this.baseUrl}/shopping-cart/name-availability/queries`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    cloudName
                })
            }));
        });
    }
    cloudNameAvailabilityCheck({ cloudName, auth }) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', generateAsapHeader(Object.assign(Object.assign({}, auth.asap), { audience: ASAP_AUDIENCE })));
            return mapResponseToJson(yield fetch(`${this.baseUrl}/name-availability/check`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    cloudName
                })
            }));
        });
    }
}
//# sourceMappingURL=cnas-client.js.map